module.exports = __webpack_public_path__ + "img/emotion-finger-up-self.27753b81.svg";